module.exports = __webpack_public_path__ + "static/media/wrong-way.69da8f1f.PNG";